import type { ReactElement } from "react";
import { memo } from "react";

import type { TIconProps } from "../types";

// NOTE: NSAI-7410 — a flat vector rendition of Microsoft Dataverse's mark (two
// interlocking leaves around a disc), traced from Pipedream's raster logo (the
// vendored PNG renders first; this is the fallback). Brand greens #0c7142
// (hsl 152 81% 25%), #2db04e (hsl 135 59% 43%), #0e8c42 (hsl 145 82% 30%) and
// #86e78c (hsl 124 66% 71%), each tinted from its own hue. The square viewBox
// is centred on the mark's bounding box.
const MicrosoftDataverseComponent = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="-1 -1 440 440"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="hsl(from hsl(152 81% 25%) h s 25%)"
      d="M300,95C260,45 160,40 95,80C30,120 -5,200 2,260C8,320 50,385 95,388C120,390 135,370 150,345Z"
    />
    <path
      fill="hsl(from hsl(135 59% 43%) h s 43%)"
      d="M300,90C320,55 345,48 370,52C410,60 438,120 438,190C438,300 340,392 250,390C200,389 165,370 145,345Z"
    />
    <circle
      cx="222"
      cy="219"
      r="100"
      fill="hsl(from hsl(145 82% 30%) h s 30%)"
    />
    <circle
      cx="219"
      cy="219"
      r="75"
      fill="hsl(from hsl(124 66% 71%) h s 71%)"
    />
  </svg>
);

// NOTE: Memoized per the repo's mandatory-memoization rule for exported
// components.
export const MicrosoftDataverse = memo(MicrosoftDataverseComponent);
